var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"id":_vm.id,"action":_vm.action,"method":_vm.method,"novalidate":_vm.novalidate,"enctype":_vm.enctype,"target":_vm.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }